import { ChargebeePlan, FlexiPlan, UserSubscription } from 'enums/user-plan';

export const findProPlan = (plan) => plan?.name === ChargebeePlan.smePro;
export const findMonthPeriod = (billing) => billing?.periodUnit === UserSubscription.month;
export const findFlexiPlan = (plan) => plan?.name === FlexiPlan.flexi10;
